import React, { useState, type FunctionComponent, type MouseEvent } from 'react'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import { openExternalLink } from '../../utils'
import { HELP_BUTTON_TEXT, ICON_WIDTH, LEARN_BUTTON_TEXT, MENU_ICON_SIZE, WHATS_NEW_BUTTON_TEXT } from './learn-button.constants'
import { HelpMenuIcon, LearnMenu, LearnMenuButton } from './learn-button.styles'
import { OpenBookIcon } from './learn-button-icon'

type LearnButtonProps = {
	helpUrl?: string,
	whatsNewUrl?: string,
	onHelpClick?: () => void,
	onWhatsNewClick?: () => void,
}

export const LearnButton: FunctionComponent<LearnButtonProps> = ( {
	helpUrl,
	whatsNewUrl,
	onHelpClick,
	onWhatsNewClick,
} ) => {
	const [ anchorEl, setAnchorEl ] = useState<HTMLButtonElement | null>( null )

	if ( !helpUrl && !whatsNewUrl ) {
		return null
	}

	const handleClick = ( event: MouseEvent<HTMLButtonElement> ) => {
		setAnchorEl( event.currentTarget )
	}

	const handleClose = () => {
		setAnchorEl( null )
	}

	const handleHelp = () => {
		handleClose()

		if ( helpUrl ) {
			openExternalLink( helpUrl )
		}

		onHelpClick?.()
	}

	const handleViewWhatsNew = () => {
		handleClose()

		if ( whatsNewUrl ) {
			openExternalLink( whatsNewUrl )
		}

		onWhatsNewClick?.()
	}

	const open = Boolean( anchorEl )

	return (
		<>
			<LearnMenuButton
				onClick={handleClick}
				startIcon={<OpenBookIcon size={ICON_WIDTH} />}
				variant="text"
			>
				{LEARN_BUTTON_TEXT}
			</LearnMenuButton>
			<LearnMenu
				anchorEl={anchorEl}
				anchorOrigin={{
					horizontal: 'left',
					vertical: 'bottom',
				}}
				onClose={handleClose}
				open={open}
				transformOrigin={{
					horizontal: 'left',
					vertical: 'top',
				}}
			>
				{helpUrl && (
					<MenuItem onClick={handleHelp}>
						<ListItemIcon>
							<HelpMenuIcon />
						</ListItemIcon>
						<ListItemText>{HELP_BUTTON_TEXT}</ListItemText>
					</MenuItem>
				)}
				{whatsNewUrl && (
					<MenuItem onClick={handleViewWhatsNew}>
						<ListItemIcon>
							<OpenBookIcon size={MENU_ICON_SIZE} />
						</ListItemIcon>
						<ListItemText>{WHATS_NEW_BUTTON_TEXT}</ListItemText>
					</MenuItem>
				)}
			</LearnMenu>
		</>
	)
}
